const APP_THEME_KEY = "app-theme";

/** Persists map theme as a plain localStorage value: app-theme = night | basic */
export class MapStorage {
  static get(): string | null {
    return localStorage.getItem(APP_THEME_KEY);
  }

  static set(theme: string): void {
    localStorage.setItem(APP_THEME_KEY, theme);
  }

  static clear(): void {
    localStorage.removeItem(APP_THEME_KEY);
  }
}
